type Props = {
  label: string
  selected: boolean
  onClick: () => void
}

export const EvaluationItem: React.FC<Props> = ({
  label,
  selected,
  onClick,
}) => {
  return (
    <button
      type='button'
      className='flex flex-1 items-center gap-4 bg-slate-100
      hover:bg-slate-200 py-2 px-3 rounded-md'
      onClick={onClick}
    >
      <div className='flex h-6 w-6 p-0.5 rounded-md border border-gpa-blue-500'>
        {selected ? (
          <div className='flex-1 rounded-[4px] bg-gpa-blue-500'></div>
        ) : null}
      </div>
      <span>{label}</span>
    </button>
  )
}
